import * as ko from 'knockout';

import { ListRequestParams } from '../api/request';
import { ListLoader, ListLoaderDelegate } from '../components/list_loader';
import * as svApi from '../api/scheduled_visits';
import { ListHeaderAction } from '../components/list_header';
import i18n from '../i18n';
import { canEditScheduledVisits } from '../permissions';
import { updateLocationWithQueryString } from '../utils';

let template = require('raw-loader!../../templates/scheduled_visit_library.html').default;

class ScheduledVisitLibraryScreen implements ListLoaderDelegate<svApi.ScheduledVisitData> {
  canEdit = canEditScheduledVisits();
  listActions = ko.observableArray<ListHeaderAction>([]);

  private nameFilter = ko.observable('').extend({ throttle: 300 });
  searchPlaceholder = i18n.t('Search scheduled visit')();
  private listLoader: ListLoader<svApi.ScheduledVisitData>;
  private subscriptions: KnockoutSubscription[] = [];

  constructor(params: { filters: { name_prefix?: string } }) {
    this.nameFilter(params.filters.name_prefix || '');

    if (this.canEdit) {
      this.listActions.push({
        title: i18n.t('Add')(),
        icon: 'add_circle',
        href: '/scheduled_visit_library/new/',
        tooltipTitle: i18n.t('Add scheduled visit')(),
      });
    }
  }

  onReady(loader: ListLoader<svApi.ScheduledVisitData>) {
    this.listLoader = loader;
    this.subscriptions.push(this.nameFilter.subscribe(() => this.listLoader.forceLoad()));
  }

  dispose() {
    this.subscriptions.forEach((s) => s.dispose());
    this.subscriptions = [];
  }

  fetch(params: ListRequestParams) {
    const filters = { name_prefix: this.nameFilter() };
    updateLocationWithQueryString(filters);
    return svApi.list({ ...params, ...filters });
  }

  instantiate(data: svApi.ScheduledVisitData) {
    return data;
  }

  remove(id: string) {
    return svApi.remove(id);
  }

  canRemove(data: svApi.ScheduledVisitData) {
    return this.canEdit;
  }
}

export const scheduledVisitLibrary = {
  name: 'scheduled-visit-library',
  viewModel: ScheduledVisitLibraryScreen,
  template,
};

ko.components.register(scheduledVisitLibrary.name, scheduledVisitLibrary);
